import { useGetApplication } from '@/app/hooks';

import { type ExcelColumnDefinition } from '../models/Payment';

const BaseUrlTaxReturnPayment = '/payments';

export const useGetDefinitionExcel = (ignoreDefaultLang?: boolean) => {
  const [{ data, loading, error }] = useGetApplication<Array<ExcelColumnDefinition>>({
    url: `${BaseUrlTaxReturnPayment}/excel-definition`,
    params: undefined,
    headers: ignoreDefaultLang ? { lang: true } : undefined
  });

  return { data, loading, error };
};
